import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/sessions/')({
  component: SessionsPage,
});

function SessionsPage() {
  return <h1>My Sessions</h1>;
}
